/**
 * Thanh điều hướng SINH TỪ DỮ LIỆU (TDD §9.3): design/extracted/routes.json là nguồn duy nhất.
 * Lọc theo entitlement (moduleCode) và capability; không viết cứng menu ở component.
 */
import routes from '../../../../design/extracted/routes.json';

export interface NavItem {
  key: string;
  label: string;
  tag: string;
  icon: string;
  moduleCode?: string | null | undefined;
  path: string;
  capability?: string | undefined;
  alwaysVisible?: boolean | undefined;
  onlyRoles?: string[] | undefined;
  /** Nhãn thay thế cho người chỉ có `selfCapability` mà không có `capability` quản lý (vd. Sale: "Hoa hồng của tôi"). */
  selfLabel?: string | undefined;
  selfCapability?: string | undefined;
}

export interface NavGroup {
  group: string | null;
  items: NavItem[];
}

export const TENANT_NAV: NavGroup[] = routes.tenant as NavGroup[];
export const PLATFORM_NAV: NavGroup[] = routes.platform as NavGroup[];
export const MODULE_LABELS: Record<string, string> = routes.moduleLabels;
/** W2 — màn nhóm quyền theo module (không phải mục menu): mockup key → đường dẫn. */
export const MODULE_PERMISSION_PATHS: Record<string, string> = Object.fromEntries(
  Object.entries(routes.modulePermissions as Record<string, string>).filter(([k]) => !k.startsWith('$')),
);

export interface NavFilter {
  hasModule: (moduleCode: string | null | undefined) => boolean;
  can: (capability: string) => boolean;
  roles: string[];
}

/** Mục có `selfLabel`: người có quyền "của tôi" nhưng không có quyền quản lý thấy nhãn riêng (BRD 4.0 v153: Sale / Sale Admin thấy "Hoa hồng của tôi"). */
function labelFor(it: NavItem, f: NavFilter): NavItem {
  if (it.selfLabel && it.selfCapability && f.can(it.selfCapability) && !(it.capability && f.can(it.capability)))
    return { ...it, label: it.selfLabel };
  return it;
}

export function filterNav(groups: NavGroup[], f: NavFilter): NavGroup[] {
  return groups
    .map((g) => ({
      group: g.group,
      items: g.items
        .filter((it) => {
          if (it.alwaysVisible) return true;
          if (it.onlyRoles && !it.onlyRoles.some((r) => f.roles.includes(r))) return false;
          if (!f.hasModule(it.moduleCode)) return false;
          if (it.capability && !f.can(it.capability) && !(it.selfCapability && f.can(it.selfCapability))) return false;
          return true;
        })
        .map((it) => labelFor(it, f)),
    }))
    .filter((g) => g.items.length > 0);
}

/** Icon đơn giản theo mã — thay bằng bộ icon SVG của design system khi có. */
export const NAV_ICON: Record<string, string> = {
  dash: '◫',
  notify: '🔔',
  report: '📊',
  product: '📦',
  crm: '👥',
  price: '🏷',
  sales: '🧾',
  social: '💬',
  loyalty: '⭐',
  aftersales: '🎧',
  dms: '🗺',
  purchase: '🛒',
  inventory: '🏬',
  mfg: '🏭',
  logistics: '🚚',
  oem: '🤝',
  credit: '💳',
  payment: '💰',
  integration: '🔌',
  admin: '⚙',
};
